import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { twMerge } from "tailwind-merge";

const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export { cn };
